import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { can } from '../../helpers/auth'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditTicket from '../../components/Customers/tickets/EditTicket'
import ViewTicket from '../../components/Customers/tickets/ViewTicket'
import ViewTicketMedia from '../../components/Customers/tickets/ViewTicketMedia'
import { useGetCustomerTicketsQuery, useLazyGetCustomerTicketsQuery } from '../../redux/apis/customersManagement/tickets/customerTicketsApiSlice'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CustomersDropdown from '../../components/CustomersDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'

const CustomerTickets = React.memo(() => {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetCustomerTicketsQuery({
    expand: ['customer'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [view, setView] = useState(false)
  const [mediaView, setMediaView] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'SUBJECT',
      dataIndex: 'subject',
      key: 'subject',
      filter: true,
      filterType: 'text'
    },

    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { value: 'open', label: 'Open' },
        { value: 'closed', label: 'Closed' },
        { value: 'in_progress', label: 'In Progress' }
      ]
    },
    {
      title: 'TICKET DATE',
      dataIndex: 'created_at',
      key: 'created_at',
      filter: true,
      filterType: 'date'
    },
    {
      title: 'LAST UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'CUSTOMER',
      dataIndex: 'customer',
      key: 'customer',
      filter: true,
      render: customer => customer?.customer_name,
      filterComponent: CustomersDropdown
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_customerticket') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
          <button
            className='btn btn-warning'
            onClick={() => handleView(record)}
          >
            View
          </button>
          <button
            className='btn btn-primary'
            onClick={() => handleViewMedia(record)}
          >
            Images
          </button>
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }
  const handleView = record => {
    setHolder(record)
    setView(true)
  }
  const handleViewMedia = record => {
    setHolder(record)
    setMediaView(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {edit && (
        <EditTicket
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}
      {view && <ViewTicket open={view} setOpen={setView} record={holder} />}
      {mediaView && (
        <ViewTicketMedia
          open={mediaView}
          setOpen={setMediaView}
          record={holder}
        />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetCustomerTicketsQuery}
            fileName='tickets'
          />
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default CustomerTickets
